import type { SiteConfig, StepItem } from '../../../siteContentTypes.ts';
import { TextField, TextAreaField, SelectField, ToggleField, ListEditor } from './fields.tsx';
import { ICON_NAMES } from '../../../lib/icons.ts';

function StepsEditor({ steps, onChange }: { steps: StepItem[]; onChange: (steps: StepItem[]) => void }) {
  return (
    <ListEditor<StepItem>
      items={steps}
      onChange={onChange}
      itemLabel="une étape"
      newItem={() => ({ number: steps.length + 1, icon: 'check', title: 'Nouvelle étape', description: '', order: steps.length, visible: true })}
      renderItem={(step, patch) => (
        <>
          <TextField label="Titre" value={step.title} onChange={(v) => patch({ title: v })} />
          <TextAreaField label="Description" value={step.description} onChange={(v) => patch({ description: v })} rows={2} />
          <SelectField label="Icône" value={step.icon} onChange={(v) => patch({ icon: v })} options={ICON_NAMES.map((n) => ({ value: n, label: n }))} />
          <ToggleField label="Visible" value={step.visible} onChange={(v) => patch({ visible: v })} />
        </>
      )}
    />
  );
}

export function HowItWorksSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const h = config.howItWorks;
  const set = (patch: Partial<SiteConfig['howItWorks']>) => update({ howItWorks: { ...h, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Comment ça marche</h2>
      <TextField label="Titre de la section" value={h.title} onChange={(v) => set({ title: v })} />

      <h3 style={{ fontSize: 14, fontWeight: 800, margin: '24px 0 10px' }}>Parcours Extra</h3>
      <StepsEditor steps={h.extraSteps} onChange={(extraSteps) => set({ extraSteps })} />

      <h3 style={{ fontSize: 14, fontWeight: 800, margin: '24px 0 10px' }}>Parcours Restaurateur</h3>
      <StepsEditor steps={h.restoSteps} onChange={(restoSteps) => set({ restoSteps })} />
    </div>
  );
}
